import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SubscriptionService } from "../../services/Subscription.service";
import { handleApiError } from "../../utils/handleApiError";
import { isLoggedIn } from "../../hooks/useAuth";
import { useI18n } from "../../i18n";
import PlanCard from "./PlanCard";

/**
 * Public qiymət səhifəsi (/plans). Login tələb olunmur —
 * paket seçiləndə qonaq əvvəlcə girişə yönləndirilir.
 */
const Plans = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await SubscriptionService.plans();
        setPlans(data.plans || []);
      } catch (error) {
        toast.error(handleApiError(error, t));
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const choose = () => {
    if (!isLoggedIn()) {
      sessionStorage.setItem("quizzo_redirect", "/subscription");
      navigate("/login");
      return;
    }
    navigate("/subscription");
  };

  return (
    <div className="max-w-6xl mx-auto page pt-10">
      <div className="text-center text-white mb-10">
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-3">{t("sub.plans_title")}</h1>
        <p className="text-indigo-100 max-w-2xl mx-auto">
          {t("sub.plans_subtitle")}
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin" />
        </div>
      ) : plans.length === 0 ? (
        <div className="bg-white rounded-3xl shadow-xl p-10 text-center max-w-lg mx-auto">
          <p className="text-5xl mb-4">📦</p>
          <p className="text-xl font-bold text-gray-800">{t("sub.no_plans")}</p>
          <p className="text-gray-500 mt-2">{t("sub.no_plans_desc")}</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {plans.map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              onSelect={choose}
              ctaLabel={
                isLoggedIn() ? t("sub.subscribe") : t("sub.login_and_subscribe")
              }
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Plans;
